import type { FormControlProps } from 'rsuite'
import type { SelectProps } from './Select'

import React from 'react'
import { Form } from 'rsuite'
import Select from './Select'

const FormControlCompatibleProxy: React.FC<SelectProps & FormControlProps> = (
  props
) => (
  <Select data={props.data} selected={props.value} onSelect={props.onChange} />
)

const FormSelect: React.FC<SelectProps & FormControlProps> = (props) => (
  <Form.Control accepter={FormControlCompatibleProxy} {...props} />
)

export default FormSelect
